import { createFeatureSelector } from '@ngrx/store';

import * as fromRailEmission from '@ruby/modules/rail-emission/store/reducers/rail-emission.reducer';

export const selectRailEmissionState = createFeatureSelector<fromRailEmission.State>(fromRailEmission.featureKey);
